var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailInfo",
              attrs: { title: "회의록 기본정보", collapsed: true },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _vm.tabParam.proceedingsTitle
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "회의제목",
                            value: _vm.tabParam.proceedingsTitle,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tabParam.proceedingsDate
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "회의일",
                            value: _vm.tabParam.proceedingsDate,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "grid1",
              attrs: {
                title: "즉시조치",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.tabParam.imprImmData,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
              },
              on: { linkClick: _vm.immlinkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "추가",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addImprImm },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "grid2",
              staticClass: "q-mt-md",
              attrs: {
                title: "개선요청",
                columns: _vm.grid2.columns,
                gridHeight: _vm.grid2.height,
                data: _vm.tabParam.imprData,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
              },
              on: { linkClick: _vm.imprlinkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "추가",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addImpr },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }